import axios from '../../axiosConfig'
import pyChar from 'js-pinyin'
import '@/apolloConfig.js'
import gql from "@/graphql/apollo"
let state = {
    loading:true,
    recommends:[],
    recommendsGroup:[],
    manageAppList:[],
    manageGuides:[],
    manageTokenList:[],
    tagApps:[],
    tagGuides:[],
    appQuery: {
		seq:'',
		tag:'',
		department:''
	},
}

let getters = {
    Loading:()=>state.loading,

    getAppList:()=>state.manageAppList,
    getTagApps:()=>state.tagApps,
    getTagGuides:()=>state.tagGuides,
    getTokenList:()=>state.manageTokenList,
    getGuides:()=>state.manageGuides,
    getState:()=>state,
}

let actions = {
    getRecommends({ state,dispatch }) {
        axios({
            method: "post",
            url: window.commonApi.TASKCENTER_URL+"/manage/apps/recommended",
        }).then(response => {
            let recommends = [];
            if(response.status == 200) {
                recommends = response.data.data;
            }
            let appIdArr = [];
            for(let i = 0; i < recommends.length; i++) {
                appIdArr.push(recommends[i].id);
            }
            state.recommends = recommends;
            if(appIdArr.length > 0) {
                dispatch('getGlById',appIdArr)
            }
        }).catch(error => {
            console.log(error); //请求失败返回的数据
        });
    },
    getGlById: function({ commit,state },appIdArr) {
        apolloProvider.clients.manage.query({
            query: gql.guide,
            letiables: {
                appId: appIdArr
            }
        })
        .then(response => {
            let edges = response.data.guide.edges;
            let recommends = state.recommends;
            for(let i = 0; i < recommends.length; i++) {
                commit('getRecommendEdges',{recommend:recommends[i], edges:edges})
            }
            let recommendsGroup = [];
            let groupCount = Math.ceil(recommends.length / 3);
            for(let i = 0; i < groupCount; i++) {
                recommendsGroup.push(recommends.splice(0, 3));
            }
            state.recommendsGroup = recommendsGroup;
            // console.log(state.recommendsGroup);
        })
        .catch(error => {})
    },
    //首页和全部事项的搜索，tag
	updateQuery({commit,state},{tag,dep}){
		
		state.appQuery.tag = tag || state.appQuery.tag ;
		state.appQuery.department = dep || state.appQuery.department ;
        
		if(tag === 'all'){
			state.appQuery.tag = '';
		}
		if(dep === 'all'){
			state.appQuery.department = '';
		}

		commit('updateAppAll');
	},
    getSearchResult({commit,state},{seq}){
        let keyword = seq || '';
        state.appQuery.seq = keyword;
        commit('loadingSet',true);
        axios.post( window.commonApi.TASKCENTER_URL+"/manage/searchGuide?keyword=" + keyword).then(response => {
            if(response.data.code === 200){
                let res = response.data.t;
                let apps = res.appList?res.appList.map((item) => {
                    let obj = item;
                    obj.hit.shouzimu = pyChar.getFullChars(item.hit.name).toUpperCase().slice(0, 1);
                    return obj;
                }):[];
                // console.log(state.manageAppList);
                state.manageAppList = apps;
                state.manageGuides = res.guideList || state.fakeGuides;
                state.manageTokenList = res.tokenList || [];
                commit('updateAppAll',apps);
                commit('loadingSet',false);
                }
            }).catch(error => {
                console.log(error); //请求失败返回的数据
                commit('loadingSet',false);
            });
        
    },
}

let mutations = {
    getRecommendEdges(state,{recommend, edges}) {
        recommend.edges = [];
        let isOk = false;
        for(let j = 0; j < edges.length; j++) {
            let guideStepList = edges[j].node.guideStepList;
            for(let k = 0; k < guideStepList.length; k++) {
                let guideStepAppList = guideStepList[k].guideStepAppList;
                for(let d = 0; d < guideStepAppList.length; d++) {
                    if(guideStepAppList[d].appCode == recommend.code) {
                        recommend.edges.push(edges[j].node);
                        isOk = true;
                        break;
                    }
                }
                if(isOk) {
                    break;
                }
            }
        }
    },

    loadingSet(state,bool){
        state.loading =  bool;
    },

    updateAppAll(state,apps){
		let all_apps = apps || state.manageAppList;
        let all_Guides = state.manageGuides;

        if(!state.appQuery.seq){
		if(state.appQuery.tag){
			all_apps = all_apps.filter((item)=>{
				return item.hit.tags && item.hit.tags.indexOf(state.appQuery.tag)>-1;
			});

            all_Guides = all_Guides.filter((item)=>{
                let isOk=false;
                let guideStepList = item.hit.guide_step;
                for(let k = 0; k < guideStepList.length; k++) {
                    let guideStepAppList = guideStepList[k].guide_step_app;
                    for(let d = 0; d < guideStepAppList.length; d++) {
                        if(guideStepAppList[d].appTag&&guideStepAppList[d].appTag.indexOf(state.appQuery.tag)>-1) {
                            isOk = true;
                        }
                    }
                }

                return isOk;
            })
		}

		if(state.appQuery.department){
			all_apps = all_apps.filter((item)=>{
				return item.hit.department && item.hit.department.indexOf(state.appQuery.department)>-1;
			});
		}

        }

		state.tagApps = all_apps;
        state.tagGuides = all_Guides;
	},
}

export default {
    namespaced: true,
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/manageApp.js